import React from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Button } from "@shadcn-in-nx/ui/button";

export default function ApiSecurityPagination({
    page,
    pageCount,
    total,
    pageSize,
    onChange,
}) {
    const { t } = useTranslation();
    if (pageCount <= 1) return null;

    const start = page * pageSize + 1;
    const end = Math.min((page + 1) * pageSize, total);

    return (
        <div className="flex items-center justify-between gap-3 mt-4 pt-3 border-t border-gray-100">
            <span className="text-xs text-gray-500">
                {t("appPreview.paginationShowing", { start, end, total }) ||
                    `Showing ${start}–${end} of ${total}`}
            </span>
            <div className="flex items-center gap-2">
                <Button
                    size="sm"
                    variant="outline"
                    className="h-7 px-2 text-xs"
                    disabled={page === 0}
                    onClick={() => onChange(page - 1)}
                >
                    <ChevronLeft className="w-3 h-3 mr-1" />
                    {t("common.previous") || "Previous"}
                </Button>
                <span className="text-xs text-gray-500">
                    {t("appPreview.pageOf", {
                        page: page + 1,
                        total: pageCount,
                    }) || `Page ${page + 1} of ${pageCount}`}
                </span>
                <Button
                    size="sm"
                    variant="outline"
                    className="h-7 px-2 text-xs"
                    disabled={page >= pageCount - 1}
                    onClick={() => onChange(page + 1)}
                >
                    {t("common.next") || "Next"}
                    <ChevronRight className="w-3 h-3 ml-1" />
                </Button>
            </div>
        </div>
    );
}
